import { Controller } from 'stimulus';

class ModalController extends Controller {
  static targets = [
    'modal',
    'adcontainer'
  ]

  initialize() {
    this.targetDom = this.element;
    if (this.hasModalTarget) {
      this.targetDom = this.modalTarget;
    }
    this.targetDom.style.transition = '0.2s all linear';
    const show = this.data.get('showState') === 'true';
    this.targetDom.classList.remove('t-hidden');
    if (show) {
      this.openModal();
    } else {
      this.targetDom.style.display = 'none';
    }
    this.domId = this.element.id;
    EventManager.on('modal_state', ({ showState, domId, handleClose = null }) => {
      if (domId == this.domId) {
        this.handleClose = handleClose;
        if (showState == 'true') {
          this.openModal();
        } else {
          this.closeModal();
        }
      }
    })
  }

  toggleModal = e => {
    if (e) {
      e.preventDefault();
    }
    const show = this.data.get('showState') === 'true';
    if (show) {
      this.closeModal(e);
    } else {
      this.openModal(e);
    }
  }

  closeModal = e => {
    if (e) {
      e.preventDefault();
    }
    this.targetDom.style.opacity = 1;
    this.targetDom.style.display = '';
    this.targetDom.style.opacity = 0;
    setTimeout(() => {
      this.targetDom.style.display = 'none';
    }, 200);
    this.data.set('showState', 'false');
    if (this.handleClose) {
      this.handleClose();
    }
  }

  openModal = e => {
    if (e) {
      e.preventDefault();
    }
    this.targetDom.style.display = '';
    this.targetDom.style.opacity = 0;
    this.targetDom.style.opacity = 1;
    this.data.set('showState', 'true');

    if (this.hasAdcontainerTarget) {
      this.adcontainerTarget.style.display = 'flex';
    }
  }
}

export default ModalController;
